// extracted by mini-css-extract-plugin
module.exports = {"howpic":"howtoplay_howpic__1aI2j","body":"howtoplay_body__1c5Fk"};